import React from 'react';
import { Outlet } from 'react-router-dom';
import { PageHeader } from '../PageHeader/PageHeader';
export var RoutedEntityPage = function (_a) {
    var model = _a.model, children = _a.children;
    return (React.createElement("div", { className: "page-scrollbar-content" },
        React.createElement(PageHeader, { model: {
                main: model.main,
                node: model.main
            } }),
        React.createElement("div", { className: "page-container page-body" },
            children,
            React.createElement(Outlet, null)),
        React.createElement("footer", { className: "footer" })));
};
//# sourceMappingURL=RoutedEntityPage.js.map